import type { wave } from '@round/api';
import type { CampaignStatus } from '@/types/creator';

type CampaignInviteReference = Pick<wave.CreatorInvite, 'id' | 'campaign_id'>;

export const getInviteIdByCampaignId = (invites: readonly CampaignInviteReference[]): ReadonlyMap<number, string> => {
    const inviteIdByCampaignId = new Map<number, string>();
    invites.forEach((invite) => {
        // The creator invites endpoint is newest first. Preserve its first match
        // if legacy data contains more than one invite for the same campaign.
        if (!inviteIdByCampaignId.has(invite.campaign_id)) {
            inviteIdByCampaignId.set(invite.campaign_id, invite.id);
        }
    });
    return inviteIdByCampaignId;
};

export const getLeftmostNonEmptyCampaignStatus = (
    statusCounts: Readonly<Record<CampaignStatus, number>>,
    statusOrder: readonly CampaignStatus[]
): CampaignStatus => statusOrder.find((status) => statusCounts[status] > 0) ?? 'invited';
